<template>
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M3.3335 3.66602H16.6668V16.4966C16.6668 17.7958 15.5021 18.666 14.3066 18.666H5.69375C4.49822 18.666 3.3335 17.7958 3.3335 16.4966V3.66602ZM5.00016 5.33268V16.4966C5.00016 16.6732 5.20269 16.9994 5.69375 16.9994H14.3066C14.7976 16.9994 15.0002 16.6732 15.0002 16.4966V5.33268H5.00016Z" :fill="props.color"/>
        <rect x="10.8335" y="7.83203" width="1.66667" height="6.66667" :fill="props.color"/>
        <rect x="7.5" y="7.83203" width="1.66667" height="6.66667" :fill="props.color"/>
        <rect x="1.6665" y="3.66602" width="16.6667" height="1.66667" :fill="props.color"/>
        <rect x="5.8335" y="2" width="8.33333" height="1.66667" :fill="props.color"/>
    </svg>

</template>

<script setup>
const props = defineProps({
    color: {
        type: String,
    }
})
</script>